import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import type { Athlete } from './athletes';
import type { Brand } from './brands';
import type { HeroRotationItem } from './heroRotation';
import type { JoinSectionData } from './joinSectionData';

type PageData = {
    csrfToken: string;
    heroRotation: HeroRotationItem[];
    athletes: Athlete[];
    brandGrid: Brand[][];
    featuredHeading: string;
    featuredBody: string;
    joinSection: JoinSectionData;
};

const pageDataEl = document.getElementById('pageData');
if (!pageDataEl) { throw new Error('Missing #pageData element'); }
const pageData: PageData = JSON.parse(pageDataEl.textContent!);

const container = document.getElementById('splash-root');
if (!container) { throw new Error('Missing #splash-root element'); }
const root = ReactDOM.createRoot(container);
root.render(React.createElement(App, pageData));

if (module.hot) { module.hot.accept(); }
